/* ===========================================================
   Jetter Pro Supply — Shopify theme behavior
   Ported from ref/assets/jps.js (chrome/drawer/menu/toast)
   Cart is wired to Shopify AJAX Cart API:
     POST /cart/add.js, GET /cart.js, POST /cart/change.js
   =========================================================== */
(function(){
  "use strict";

  var FREE_SHIP = 19900; // cents — free shipping threshold ($199)

  /* ---- money + stars helpers (kept on window for snippets) ---- */
  function JPS_money(cents){
    cents = parseInt(cents, 10) || 0;
    var fmt = window.JPS_MONEY_FORMAT || "${{amount}}";
    var amount = cents / 100;
    // Support Shopify money_format placeholders.
    function withComma(n, dec){
      return n.toLocaleString("en-US", {minimumFractionDigits:dec, maximumFractionDigits:dec});
    }
    function noComma(n, dec){
      return n.toFixed(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case "amount":                 return withComma(amount, 2);
        case "amount_no_decimals":     return withComma(Math.round(amount), 0);
        case "amount_with_comma_separator":     return amount.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});
        case "amount_no_decimals_with_comma_separator": return Math.round(amount).toLocaleString("de-DE");
        case "amount_with_space_separator":     return withComma(amount,2).replace(/,/g," ");
        default:                       return noComma(amount, 2);
      }
    });
  }
  window.JPS_money = JPS_money;

  function JPS_stars(r){
    r = parseFloat(r) || 0;
    var full = Math.floor(r), half = (r % 1) >= 0.5;
    return "\u2605".repeat(full) + (half ? "\u00BD" : "") + "\u2606".repeat(Math.max(0, 5 - full - (half ? 1 : 0)));
  }
  window.JPS_stars = JPS_stars;

  /* ===========================================================
     TOAST
     =========================================================== */
  var toastTimer;
  function showToast(msg){
    var t = document.getElementById("toast"), m = document.getElementById("toastMsg");
    if(!t) return;
    if(m) m.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2400);
  }
  window.JPS_toast = showToast;

  /* ===========================================================
     DRAWER open/close
     =========================================================== */
  function openDrawer(){
    var d = document.getElementById("cartDrawer"), o = document.getElementById("drawerOverlay");
    if(d){ d.classList.add("open"); if(o) o.classList.add("open"); }
  }
  function closeDrawer(){
    var d = document.getElementById("cartDrawer"), o = document.getElementById("drawerOverlay");
    if(d){ d.classList.remove("open"); if(o) o.classList.remove("open"); }
  }
  window.JPS_openDrawer = openDrawer;
  window.JPS_closeDrawer = closeDrawer;

  /* ===========================================================
     SHOPIFY CART (AJAX)
     =========================================================== */
  var cartState = { items: [], item_count: 0, total_price: 0 };

  /* JPS_LOADOUT_OFFER_START
     Three verified 3/8- or 1/2-inch nozzles earn the matching case. Shopify's
     BXGY rule makes the automatically added case free at cart and checkout. */
  var LOADOUT_ELIGIBLE = ["1-2-victory-line-cleaning-nozzle","1-2-victory-line-rotor-nozzle","1-2-victory-line-traction-nozzle-with-forward","aqua-power-mini-1-2","ball-nozzle-forward-jet-three-eighths","ball-nozzle-three-eighths","ball-nozzle-w-forward-jet-1-2","cleaning-nozzle-half-inch","cleaning-nozzle-three-eighths","duce-nozzle-1-2","duce-nozzle-three-eighths","egg-devastator-nozzle-1-2","egg-devastator-nozzle-three-eighths","egg-nozzle-1-2","egg-nozzle-forward-jet-three-eighths","forward-jet-nozzle-1-2","hand-injector-nozzle-1-2","quattro-hydro-excavating-nozzle-half-inch","quattro-nozzle-drill-point-half-inch","quattro-nozzle-drill-point-three-eighths","quattro-nozzle-forward-jets-half-inch","quattro-nozzle-forward-jets-three-eighths","rambo-nozzle-half-inch","rambo-nozzle-three-eighths","rotor-nozzle-45-degree-half-inch","rotor-nozzle-90-degree-half-inch","rotor-nozzle-three-eighths","sewer-flush-nozzle-1-2","sewer-flush-nozzle-3-8","sewer-flush-nozzle-three-eighths","standard-nozzle-forward-jet-three-eighths","standard-nozzle-half-inch","traction-nozzle-forward-jet-half-inch","traction-nozzle-forward-jet-three-eighths","twister-nozzle-1-2","victory-line-egg-w-forward-jet-1-2","victory-line-poking-nozzle-egg-devastator-1-2","victory-line-quattro-w-forward-chisel-1-2","victory-line-rambo-nozzle-1-2"];
  var LOADOUT_CASE_VARIANT = 53283008577904;
  var loadoutSyncing = false;

  function loadoutNozzleCount(cart){
    return (cart.items || []).reduce(function(total,line){
      return total + (LOADOUT_ELIGIBLE.indexOf(line.handle) >= 0 ? line.quantity : 0);
    },0);
  }
  function loadoutGiftLines(cart){
    return (cart.items || []).filter(function(line){
      return line.properties && line.properties._jps_loadout_case === "3-nozzle matched case";
    });
  }
  function rawCartChange(key,quantity){
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:quantity})}).then(function(r){if(!r.ok)throw new Error("Gift cart update failed");return r.json();});
  }
  function rawGiftAdd(){
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:LOADOUT_CASE_VARIANT,quantity:1,properties:{_jps_loadout_case:"3-nozzle matched case"}}]})}).then(function(r){if(!r.ok)throw new Error("Gift case unavailable");return r.json();}).then(function(){return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();});});
  }
  function syncLoadoutGift(cart){
    if(loadoutSyncing)return Promise.resolve(cart);
    var count=loadoutNozzleCount(cart), gifts=loadoutGiftLines(cart), shouldHave=count>=3;
    loadoutSyncing=true;
    var work=Promise.resolve(cart);
    if(shouldHave && gifts.length===0)work=rawGiftAdd();
    else if(shouldHave && (gifts.length>1 || gifts[0].quantity!==1)){
      work=rawCartChange(gifts[0].key,1);
      gifts.slice(1).forEach(function(line){work=work.then(function(c){return rawCartChange(line.key,0);});});
    } else if(!shouldHave && gifts.length){
      gifts.forEach(function(line){work=work.then(function(c){return rawCartChange(line.key,0);});});
    }
    return work.catch(function(){return cart;}).then(function(finalCart){loadoutSyncing=false;return finalCart;});
  }
  function loadoutOfferHtml(cart){
    var count=loadoutNozzleCount(cart), remaining=Math.max(0,3-count), copy;
    if(count>=4)copy="Complete four-nozzle loadout unlocked: your matching fitted case is free. You are also entered in this month’s $100 JPS credit drawing. <a href=\"/pages/monthly-loadout-drawing\" style=\"font-weight:800;color:#0b5794\">No purchase necessary—free entry and rules.</a>";
    else if(count===3)copy="Free matching case unlocked. Add the fourth job-specific nozzle to complete your loadout and receive automatic entry in this month’s $100 JPS credit drawing. <a href=\"/pages/monthly-loadout-drawing\" style=\"font-weight:800;color:#0b5794\">No purchase necessary—free entry and rules.</a>";
    else copy="Add "+remaining+" more matched 3/8- or 1/2-inch nozzle"+(remaining===1?"":"s")+" for a free fitted case.";
    return '<div class="jps-loadout-offer" style="margin:12px 0;padding:12px;border:1px solid #b9d5ec;border-radius:8px;background:#edf7ff;color:#153a5a;font-size:13px;line-height:1.4"><b>Build your truck loadout</b><br>'+copy+'</div>';
  }
  /* JPS_LOADOUT_OFFER_END */

  function fetchCart(){
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(r){ return r.json(); })
      .then(syncLoadoutGift)
      .then(function(cart){ cartState = cart; renderCart(cart); document.dispatchEvent(new CustomEvent("jps:cart:updated",{detail:cart})); return cart; });
  }
  window.JPS_refreshCart = fetchCart;

  function addToCart(variantId, qty, properties){
    qty = parseInt(qty, 10) || 1;
    var item = { id: variantId, quantity: qty };
    if(properties && typeof properties === "object"){
      var keys = Object.keys(properties);
      if(keys.length){ item.properties = properties; }
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function(r){
      if(!r.ok){ return r.json().then(function(e){ throw e; }); }
      return r.json();
    }).then(function(added){
      return fetchCart().then(function(){
        var name = (added && (added.product_title || added.title)) || "Item";
        showToast(name.replace(/\s*\(.*\)\s*$/, "") + " added to cart");
        openDrawer();
      });
    }).catch(function(err){
      showToast((err && err.description) ? err.description : "Could not add item");
    });
  }
  window.JPS_addToCart = addToCart;

  function changeLine(key, qty){
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(syncLoadoutGift)
      .then(function(cart){ cartState = cart; renderCart(cart); document.dispatchEvent(new CustomEvent("jps:cart:updated",{detail:cart})); return cart; });
  }
  window.JPS_changeLine = changeLine;

  function renderCart(cart){
    cart = cart || cartState;

    /* header count badges */
    document.querySelectorAll("[data-cart-count]").forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : el.style.display;
    });

    var items = document.getElementById("drawerItems");
    var foot  = document.getElementById("drawerFoot");
    if(!items) return;

    if(!cart.items || cart.items.length === 0){
      items.innerHTML = '<div class="dempty"><svg viewBox="0 0 24 24" stroke-width="1.6"><circle cx="9" cy="21" r="1.4"/><circle cx="18" cy="21" r="1.4"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" stroke-linecap="round" stroke-linejoin="round"/></svg><p>Your cart is empty.</p></div>';
      if(foot) foot.style.display = "none";
      return;
    }
    if(foot) foot.style.display = "block";

    items.innerHTML = cart.items.map(function(l){
      var img = l.image
        ? '<div class="dthumb"><img src="'+l.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_120x$1")+'" alt="'+escapeHtml(l.product_title)+'" style="width:100%;height:100%;object-fit:contain;background:#fff;"></div>'
        : '<div class="dthumb ph"><span class="tag">img</span></div>';
      var propsHtml = "";
      if(l.properties){
        var pk = Object.keys(l.properties).filter(function(k){ return k.charAt(0) !== "_" && (l.properties[k]+"").trim(); });
        if(pk.length){
          propsHtml = '<div class="dprops">' + pk.map(function(k){
            return '<span><b>'+escapeHtml(k)+':</b> '+escapeHtml(l.properties[k])+'</span>';
          }).join("") + '</div>';
        }
      }
      return '<div class="ditem" data-key="'+l.key+'">'+
        img +
        '<div class="dinfo">'+
          '<div class="dname"><a href="'+l.url+'">'+escapeHtml(l.product_title)+'</a></div>'+
          '<div class="dprice">'+JPS_money(l.final_price)+'</div>'+
          propsHtml +
          '<div class="qty"><button data-dec="'+l.key+'">\u2212</button><span>'+l.quantity+'</span><button data-inc="'+l.key+'">+</button></div>'+
          '<button class="dremove" data-rm="'+l.key+'">Remove</button>'+
        '</div></div>';
    }).join("");
    items.insertAdjacentHTML("beforeend", loadoutOfferHtml(cart));

    var sub = cart.total_price;
    var subEl = document.getElementById("drawerSubtotal");
    if(subEl) subEl.textContent = JPS_money(sub);

    var remain = Math.max(0, FREE_SHIP - sub);
    var bar = document.getElementById("shipBar");
    var msg = document.getElementById("shipMsg");
    if(bar) bar.style.width = Math.min(100, (sub / FREE_SHIP) * 100) + "%";
    if(msg) msg.innerHTML = remain > 0
      ? ('Add <b>' + JPS_money(remain) + '</b> for FREE shipping')
      : '<b>You qualify for FREE shipping!</b>';

    /* wire qty + remove */
    items.querySelectorAll("[data-inc]").forEach(function(b){
      b.onclick = function(){ var l = findLine(b.dataset.inc); if(l) changeLine(b.dataset.inc, l.quantity + 1); };
    });
    items.querySelectorAll("[data-dec]").forEach(function(b){
      b.onclick = function(){ var l = findLine(b.dataset.dec); if(l) changeLine(b.dataset.dec, l.quantity - 1); };
    });
    items.querySelectorAll("[data-rm]").forEach(function(b){
      b.onclick = function(){ changeLine(b.dataset.rm, 0); };
    });
  }
  window.JPS_renderCart = renderCart;

  function findLine(key){
    for(var i=0;i<cartState.items.length;i++){ if(cartState.items[i].key === key) return cartState.items[i]; }
    return null;
  }
  function escapeHtml(s){
    return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  }

  /* ===========================================================
     SEARCH suggestions (lightweight — submit goes to /search)
     =========================================================== */
  function wireSearch(){
    document.querySelectorAll(".search-form").forEach(function(form){
      var box = form.querySelector(".suggest");
      if(box){
        var input = form.querySelector("input[name='q']") || form.querySelector("input");
        document.addEventListener("click", function(e){ if(!form.contains(e.target)) box.classList.remove("open"); });
      }
      /* let native GET submit to /search?q= */
    });
  }

  /* ===========================================================
     MEGA MENU ("Shop By Category")
     =========================================================== */
  function wireMega(){
    var btn = document.getElementById("shopcatBtn"),
        mega = document.getElementById("mega"),
        ov  = document.getElementById("megaOverlay");
    if(!btn || !mega) return;
    function toggle(open){
      btn.classList.toggle("open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      mega.classList.toggle("open", open);
      if(ov) ov.classList.toggle("open", open);
    }
    btn.addEventListener("click", function(e){ e.stopPropagation(); toggle(!mega.classList.contains("open")); });
    if(ov) ov.addEventListener("click", function(){ toggle(false); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") toggle(false); });
  }

  /* ===========================================================
     MOBILE NAV
     =========================================================== */
  function wireMobile(){
    var open  = document.getElementById("hamburger"),
        nav   = document.getElementById("mnav"),
        ov    = document.getElementById("mnavOverlay"),
        close = document.getElementById("mnavClose");
    if(!open || !nav) return;
    function set(o){
      nav.classList.toggle("open", o);
      if(ov) ov.classList.toggle("open", o);
      document.body.style.overflow = o ? "hidden" : "";
    }
    open.addEventListener("click", function(){ set(true); });
    if(close) close.addEventListener("click", function(){ set(false); });
    if(ov) ov.addEventListener("click", function(){ set(false); });
  }

  /* ===========================================================
     ADD-TO-CART intercept (buttons + forms)
     =========================================================== */
  /* Read the optional "Tell us about your jetter" fields on the product page.
     Returns line-item properties (visible on the Shopify order) so JPS can
     confirm/recommend the right nozzle. Skips empty fields. */
  function collectJetterProps(){
    var map = [
      ["jsGpm",     "Jetter Flow (GPM)"],
      ["jsPsi",     "Jetter Pressure (PSI)"],
      ["jsHose",    "Hose ID"],
      ["jsLength",  "Hose Length (ft)"],
      ["jsApp",     "Application"],
      ["jsMachine", "Machine Make/Model"],
      ["jsNotes",   "Pipe Size / Notes"]
    ];
    var props = {};
    for(var i=0;i<map.length;i++){
      var el = document.getElementById(map[i][0]);
      if(el){
        var v = (el.value || "").trim();
        if(v){ props[map[i][1]] = v; }
      }
    }
    return props;
  }

  /* Normalize a hose-size string to a canonical token like 1/4" | 3/8" | 1/2" | 5/8" | 3/4" | 1" */
  function normHose(s){
    s = (s || "").toString();
    if(s.indexOf("1/4") >= 0) return '1/4"';
    if(s.indexOf("3/8") >= 0) return '3/8"';
    if(s.indexOf("1/2") >= 0) return '1/2"';
    if(s.indexOf("5/8") >= 0) return '5/8"';
    if(s.indexOf("3/4") >= 0) return '3/4"';
    if(/(^|[^\d/])1"?($|[^\d/])/.test(s) || s.trim() === '1"' || s.trim() === '1') return '1"';
    return "";
  }
  /* Map a hose token to the matching per-size collection so we can send the customer to the right kits */
  function hoseCollection(tok){
    var m = { '1/4"':"1-4-inch-jetter-nozzles", '3/8"':"3-8-inch-jetter-nozzles", '1/2"':"1-2-inch-jetter-nozzles", '1"':"1-1-4-inch-jetter-nozzles" };
    return m[tok] || null;
  }

  /* Require rated machine flow for nozzle and nozzle-kit purchases, then run
     the existing hose-fit guard when the customer provides hose details. */
  function validateJetterFit(b){
    var fit = document.getElementById("jsFit");
    var gpmEl = document.getElementById("jsGpm");
    var hoseEl = document.getElementById("jsHose");
    var lenEl  = document.getElementById("jsLength");
    var requiresGpm = b.getAttribute("data-requires-gpm") === "1";
    if(!gpmEl && !hoseEl && !lenEl){ return { ok:true }; } /* form not present */

    /* clear prior error styling */
    document.querySelectorAll(".js-grid label.js-err").forEach(function(l){ l.classList.remove("js-err"); });

    var rawGpm = gpmEl ? (gpmEl.value || "").trim() : "";
    var gpm = Number(rawGpm);
    var hose = hoseEl ? (hoseEl.value || "").trim() : "";
    var len  = lenEl ? (lenEl.value || "").trim() : "";

    function openForm(){ var s = document.getElementById("jetterSetup"); if(s) s.open = true; }

    if(requiresGpm && (!rawGpm || !Number.isFinite(gpm) || gpm <= 0 || gpm > 200)){
      openForm();
      if(gpmEl){ gpmEl.closest("label").classList.add("js-err"); try { gpmEl.focus(); } catch(e){} }
      return { ok:false, block:true,
        html: '<b>Enter your jetter’s rated GPM before adding this item.</b> Use the flow shown on the pump or machine plate. We attach it to the order so JPS can verify the nozzle configuration before shipment.' };
    }

    /* Hose ID and hose length improve the fit check but remain recommended. */
    if(!hose || !len){ return { ok:true }; }

    /* mismatch guard: customer hose vs. product hose */
    var prodTok = normHose(b.getAttribute("data-hose"));
    var custTok = normHose(hose);
    var notSure = /not\s*sure/i.test(hose);

    if(prodTok && custTok && prodTok !== custTok){
      openForm();
      if(hoseEl) hoseEl.closest("label").classList.add("js-err");
      var coll = hoseCollection(custTok);
      var cta = coll
        ? '<a class="js-fit-cta" href="/collections/' + coll + '">Shop ' + custTok + ' nozzles &amp; kits \u2192</a>'
        : '<a class="js-fit-cta" href="tel:8648046637">Call (864) 804-6637 for the right fit</a>';
      return { ok:false, block:true, warn:false, allowOverride:true,
        html: 'This is a <b>' + prodTok + '</b> setup, but your hose is <b>' + custTok + '</b>. '
            + 'A ' + prodTok + ' nozzle will <b>not</b> thread onto a ' + custTok + ' line \u2014 you\u2019d get the wrong kit. '
            + 'Get the one built for your hose:<br>' + cta
            + '<button type="button" class="js-fit-anyway" id="jsAddAnyway">Add anyway \u2014 I know my fit</button>' };
    }

    if(notSure){
      openForm();
      return { ok:false, block:false, warn:true,
        html: 'Not sure of your hose ID? That\u2019s the one spec that decides fit. '
            + '<a href="/pages/nozzle-guide">Find it in 30 seconds \u2192</a> or call <a href="tel:8648046637">(864) 804-6637</a>. '
            + 'You can still add to cart \u2014 we double-check fit before every order ships.' };
    }

    return { ok:true };
  }

  function showFit(res){
    var fit = document.getElementById("jsFit");
    if(!fit) return;
    if(!res || res.ok){ fit.hidden = true; fit.className = "js-fit"; fit.innerHTML = ""; return; }
    fit.hidden = false;
    fit.className = "js-fit " + (res.block ? "is-block" : "is-warn");
    fit.innerHTML = res.html;
    if(res.allowOverride){
      var anyway = fit.querySelector("#jsAddAnyway");
      if(anyway){
        anyway.addEventListener("click", function(){
          window.__jpsFitOverride = true;
          var addBtn = document.getElementById("pdpAdd");
          if(addBtn){ addBtn.click(); }
        });
      }
    }
    try { fit.scrollIntoView({ behavior:"smooth", block:"center" }); } catch(e){}
  }

  function wireAddToCart(){
    /* clear fit message as the customer corrects the fields */
    ["jsGpm","jsHose","jsLength"].forEach(function(id){
      var e = document.getElementById(id);
      if(e) e.addEventListener("change", function(){ showFit({ ok:true }); });
    });

    /* delegate [data-add="<variantId>"] buttons anywhere */
    document.body.addEventListener("click", function(e){
      var b = e.target.closest("[data-add]");
      if(b){
        e.preventDefault();
        var vid = b.getAttribute("data-add");
        if(!vid) return;
        /* PDP jetter add: enforce hose fit before anything hits the cart */
        var isJetter = (b.getAttribute("data-jetter") === "1");
        if(isJetter){
          if(window.__jpsFitOverride){
            /* customer explicitly chose "Add anyway" on a size mismatch */
            window.__jpsFitOverride = false;
            showFit({ ok:true });
          } else {
            var res = validateJetterFit(b);
            if(!res.ok){ showFit(res); if(res.block){ return; } }
            else { showFit({ ok:true }); }
          }
        }
        var qty = parseInt(b.getAttribute("data-qty") || "1", 10);
        /* if a qty input is associated via data-qty-source, read it */
        var src = b.getAttribute("data-qty-source");
        if(src){ var qi = document.querySelector(src); if(qi) qty = parseInt(qi.value, 10) || 1; }
        /* collect jetter setup line-item properties if this is the PDP add button */
        var props = isJetter ? collectJetterProps() : null;
        b.disabled = true;
        addToCart(vid, qty, props).then(function(){ b.disabled = false; });
      }
    });

    /* intercept standard product add-to-cart forms (action contains /cart/add) */
    document.body.addEventListener("submit", function(e){
      var form = e.target.closest('form[action*="/cart/add"]');
      if(!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch("/cart/add.js", { method:"POST", headers:{ "Accept":"application/json" }, body: fd })
        .then(function(r){ if(!r.ok){ return r.json().then(function(x){ throw x; }); } return r.json(); })
        .then(function(added){
          return fetchCart().then(function(){
            var name = (added && (added.product_title || added.title)) || "Item";
            showToast(name.replace(/\s*\(.*\)\s*$/, "") + " added to cart");
            openDrawer();
          });
        })
        .catch(function(err){ showToast((err && err.description) ? err.description : "Could not add item"); });
    });
  }

  /* ===========================================================
     INIT
     =========================================================== */
  document.addEventListener("DOMContentLoaded", function(){
    wireSearch(); wireMega(); wireMobile(); wireAddToCart();

    /* open cart drawer triggers */
    document.querySelectorAll("[data-open-cart]").forEach(function(b){
      b.addEventListener("click", function(e){ e.preventDefault(); openDrawer(); });
    });
    var dc = document.getElementById("drawerClose");   if(dc) dc.addEventListener("click", closeDrawer);
    var dov = document.getElementById("drawerOverlay"); if(dov) dov.addEventListener("click", closeDrawer);
    var cs = document.getElementById("continueShop");  if(cs) cs.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeDrawer(); });

    /* initial cart hydrate */
    fetchCart();
  });
})();
